export enum ConsentDecision {
  GRANTED = 'granted',
  DENIED = 'denied',
}

export const CONSENT_STORAGE_KEY = 'kemaro-cloud-cookie-consent';
export const CONSENT_VERSION_STORAGE_KEY = 'kemaro-cloud-cookie-consent-version';
export const CONSENT_VERSION = 2;
export const CONSENT_CHANGE_EVENT = 'kemaro-cookie-consent-change';

export const PRIVACY_POLICY_URL = 'https://sphere.kemaro.ch/legal/?t=privacypolicy';

export function getConsent(): ConsentDecision | null {
  if ((navigator as any).globalPrivacyControl === true) {
    return ConsentDecision.DENIED;
  }
  try {
    const value = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (value === ConsentDecision.DENIED) return value;
    if (value === ConsentDecision.GRANTED) {
      const version = Number(localStorage.getItem(CONSENT_VERSION_STORAGE_KEY) ?? '1');
      return version >= CONSENT_VERSION ? value : null;
    }
    return null;
  } catch {
    return null;
  }
}

export function setConsent(decision: ConsentDecision): void {
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, decision);
    localStorage.setItem(CONSENT_VERSION_STORAGE_KEY, String(CONSENT_VERSION));
  } catch {
    // localStorage unavailable (private mode/quota) — skip persistence.
  }
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGE_EVENT));
}
